import { McIcon } from "./icon.js"


export class McIconHamburgerMenu extends McIcon {

  constructor() {
    super()
    const temp = document.createElement("template")
    temp.innerHTML = `
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
  <g id="SVGRepo_iconCarrier"> 
    <path d="M4 7L7 7M20 7L11 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">
    </path> <path d="M20 17H17M4 17L13 17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">
    </path> <path d="M4 12H7L20 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path> 
  </g>
</svg>
`
    super.addHTML(temp)
  }
}

if (!window.customElements.get("mc-icon-hamburgermenu")) window.customElements.define("mc-icon-hamburgermenu", McIconHamburgerMenu)

